import { Scissors, Sparkles, Stethoscope, HeartPulse, Dog, Briefcase } from "lucide-react";

const USE_CASES = [
  {
    icon: Scissors,
    title: "Salons & Barbers",
    body: "Keep chairs full. Rebook every color, cut, and touch-up right on time.",
    image: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=800&q=80&auto=format&fit=crop",
  },
  {
    icon: Sparkles,
    title: "Med Spas",
    body: "Sequence Botox, filler, and facial series without a call queue.",
    image: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxzcGElMjBmYWNpYWx8ZW58MHx8fHwxNzgzMDU4OTU4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Stethoscope,
    title: "Dentists",
    body: "6-month cleanings that actually rebook. Reviews after every good visit.",
    image: "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxkZW50aXN0JTIwZG9jdG9yJTIwYXBwb2ludG1lbnR8ZW58MHx8fHwxNzgzMDU4OTUzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: HeartPulse,
    title: "Wellness Studios",
    body: "Fill classes, sell packages, and bring lapsed members back gently.",
    image: "https://images.unsplash.com/photo-1667061481921-b31e615ae740?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHx5b2dhJTIwd2VsbG5lc3MlMjBzdHVkaW98ZW58MHx8fHwxNzgzMDU4OTU4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Dog,
    title: "Pet Groomers",
    body: "Every wash, every clip — a caring reminder before their coat outgrows the last visit.",
    image: "https://images.unsplash.com/photo-1528846104175-4fd300ee59da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxwZXQlMjBncm9vbWVyJTIwZG9nJTIwc3BhfGVufDB8fHx8MTc4MzA1ODk1M3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Briefcase,
    title: "Consultants & Coaches",
    body: "Turn one great session into a series. Reviews, referrals, and rebookings — quietly.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80&auto=format&fit=crop",
  },
];

export default function UseCases() {
  return (
    <section id="use-cases" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="max-w-2xl mb-14">
          <div className="overline mb-4">Made for appointment-based businesses</div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#183D36]">
            If your calendar is your revenue, NextVisit is for you.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {USE_CASES.map((u) => {
            const Icon = u.icon;
            return (
              <div key={u.title} data-testid={`use-case-${u.title.split(' ')[0].toLowerCase()}`}
                className="group rounded-3xl overflow-hidden border border-[#E5E0D8] bg-white hover:shadow-lg transition-all hover:-translate-y-1">
                <div className="aspect-[16/10] overflow-hidden bg-[#EFECE5]">
                  <img
                    src={u.image}
                    alt={u.title}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="w-9 h-9 rounded-2xl bg-[#183D36]/8 flex items-center justify-center">
                      <Icon size={16} strokeWidth={1.75} className="text-[#183D36]" />
                    </span>
                    <h3 className="font-heading text-xl text-[#183D36]">{u.title}</h3>
                  </div>
                  <p className="text-[#4A4A4A] leading-relaxed text-sm">{u.body}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
